import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  gettheMyonboardignlisteddatas,
  setthemyonboardingListedDatas,
  SetEmployeeProfileDetailsID,
  //---forms----
  SetBasiformsID,
  SetAddressId,
  SetJobOfferID,
  SetIdVeriications,
  setBankDetailsId,
  SetEducationDetails,
  SetPreviousEmployeeID,
  setfamliydetailsid,
  SetEsiFormIdActions,
  SetDeclarationId,
  SETBASICFORMcreatedetails,
  setTheUser_ID, //---user_id
  SetISPendingDetails,
  setTheAllFormPdf,
  SetStatusBTN,
  setEditableActions,
  setGeoLoactionStateAction,
  setZoneActions,
  setRegionActions,
  setClientBranchSearchAction,
  getSingleEmployeeActions,
  setheMyOnboardingRequestState,
  setheMyOnboardingRequesteRegion,
  setheMyOnboardingRequestZone,
  setTheMyonboardingRequestRange1,
  setTheMyOnboardingRequestRange2,
  setTheMyonboardingRequestBranchList,
  setTheApproveRequeststate,
  setTheRoleObjects,
  SettheBracnhId,
  setTheZoneObjectinEmployeeList,
  setTheemployeeRoleId,
  settheJobinfoBranchEmployeeProfile,
  setTheBranchoptionsFieldAgent,
  setTablePositionPersist,
  setSelectedOnboardClient,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import _ from "lodash";
import useDebouncedEffect from "use-debounced-effect";

const MyonboardingTab = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist,
  );
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.MyonboardingTempPage?.page == undefined
      ? 1
      : TablePositionPersist.MyonboardingTempPage.page,
  );
  const [dtpagesize, setdtPagesize] = useState(10);
  const [search, setsearch] = useState(
    TablePositionPersist?.MyonboardingTempPage?.search == "" ||
      TablePositionPersist?.MyonboardingTempPage?.search == undefined
      ? ""
      : TablePositionPersist.MyonboardingTempPage.search,
  );
  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [nameList5, setOptions5] = useState([]);
  const [nameList4, setOptions4] = useState([]);

  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
    Clientsearch: "",
  };

  const [SearchDebounance, setSearchDebounance] = useState(
    initialDebouanceSearch,
  );

  const [searchBranch, setSearch] = useState("");

  const [multiselect, setMuliselect] = useState(
    state.StateManagementOverallCall.Myonboarding_RequestState,
  );
  const [multiselect1, setMuliselect1] = useState(
    state.StateManagementOverallCall.Myonboarding_RequestRegion,
  );
  const [multiselect3, setMuliselect3] = useState(
    state.StateManagementOverallCall.Myonboarding_RequestZone,
  );
  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(state.StateManagementOverallCall.Myonboarding_Range1);
  var gt = convert(state.StateManagementOverallCall.Myonboarding_Range2);

  const [range, setrange] = useState(
    state.StateManagementOverallCall.Myonboarding_Range1 == "" ? [] : [it, gt],
  );
  console.log(
    state.StateManagementOverallCall.Myonboarding_Range1,
    "Myonboarding_Range1",
  );

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const navigate = useNavigate();
  const FileterState = {
    is_pending:
      state.NeededdatasListed.MyonboardingList?.value == "1"
        ? ""
        : state.NeededdatasListed.MyonboardingList?.value == "2"
          ? true
          : "",
    is_decline:
      state.NeededdatasListed.MyonboardingList?.value == "1"
        ? ""
        : state.NeededdatasListed.MyonboardingList?.value == "3"
          ? true
          : state.NeededdatasListed.MyonboardingList?.value == "2"
            ? false
            : "",
    approved:
      state.NeededdatasListed.MyonboardingList?.value == "1"
        ? ""
        : state.NeededdatasListed.MyonboardingList?.value == "4"
          ? true
          : "",
  };

  const [selectVal, SetSelectval] = useState(FileterState);
  // setthemyonboardingListedDatas
  const options = [
    { value: "1", label: "All" },
    { value: "2", label: "Pending" },
    { value: "3", label: "Rejected" },
    { value: "4", label: "Approved" },
  ];

  const [datas, setData] = useState({
    zone: state.StateManagementOverallCall.Myonboarding_RequestZone?.value,
    state: state.StateManagementOverallCall.Myonboarding_RequestState?.value,
    region: state.StateManagementOverallCall.Myonboarding_RequestRegion?.value,
  });

  ////---for the edit
  useEffect(() => {
    dispatch(setEditableActions(2));
    dispatch(setTheApproveRequeststate(5));
  }, []);

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setTheMyonboardingRequestRange1(range[0]));
      dispatch(setTheMyOnboardingRequestRange2(range[1]));
    }
  }, [range]);
  useEffect(() => {
    // if (range.length > 0 && !range.includes("NaN-aN-aN")) {
    const payloads = {
      search: search,
      page_size: 20,
      page: dtpageindex,
      client:
        state.StateManagementOverallCall.Myonboarding_RequestBranchList?.value,
      is_pending: selectVal.is_pending,
      is_decline: selectVal.is_decline,
      approved: selectVal.approved,
      state: datas.state,
      region: datas.region,
      zone: datas.zone,
      // from_date: range[0],
      // to_date: range[1],
      // range: range[0] != range[1] ? true : false,
    };
    dispatch(gettheMyonboardignlisteddatas(payloads));
    dispatch(
      setTablePositionPersist({
        data: payloads,
        pageName: "MyonboardingTempPage",
      }),
    );
    // }
  }, [
    search,
    selectVal,
    dtpageindex,
    // range,
    datas,
    state.StateManagementOverallCall.Myonboarding_RequestBranchList,
  ]);

  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, searchBranch]);

  useEffect(() => {
    const payload = {
      search: searchBranch,
      page_size: 30,
      page: 1,
      data: datas,
    };
    dispatch(setClientBranchSearchAction(payload));

    //  console.log(state.ClientBranch.ClientBranchess, "asdasd");
  }, [searchBranch, datas]);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);

  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: datas.region,
    };
    dispatch(setZoneActions(payloads));
  }, [datas.region, SearchedVal.zoneSearch]);
  useEffect(() => {
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions5(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: datas.state,
    };
    dispatch(setRegionActions(payloads));
  }, [datas.state, SearchedVal.regionSearch]);

  useEffect(() => {
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  const HandleInputBranch = (e) => {
    setSearchDebounance({
      ...SearchDebounance,
      Clientsearch: e,
    });
  };

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  function tochange(e) {
    setdtPageindex(1);
    // setsearch(e);

    debouncedSearch(e);
  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    [],
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handlechangedate = (value) => {
    setdtPageindex(1);

    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };
  const HandleClientBranches = (selectedVal) => {
    setdtPageindex(1);
    if (selectedVal != null) {
      dispatch(setTheMyonboardingRequestBranchList(selectedVal));

      dispatch(getSingleEmployeeActions(selectedVal.value)); /// branch=---list
    } else if (selectedVal == null) {
      dispatch(getSingleEmployeeActions("")); /// branch=---list
      dispatch(
        setTheMyonboardingRequestBranchList({ value: "", label: "ALL" }),
      );
    }
  };

  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    setdtPageindex(1);
    dispatch(setTheMyonboardingRequestBranchList({ value: "", label: "ALL" }));

    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setheMyOnboardingRequesteRegion(selectedVal));
      dispatch(setheMyOnboardingRequestZone({ value: "", label: "ALL" }));

      setData({
        ...datas,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setData({
        ...datas,
        region: "",
        zone: "",
      });
      dispatch(setheMyOnboardingRequesteRegion({ value: "", label: "ALL" }));
      dispatch(setheMyOnboardingRequestZone({ value: "", label: "ALL" }));

      setMuliselect3({ value: "", label: "ALL" });

      setMuliselect1({ value: "", label: "ALL" });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    setdtPageindex(1);
    dispatch(setTheMyonboardingRequestBranchList({ value: "", label: "ALL" }));

    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...datas,
        zone: selectedVal.value,
      });
      dispatch(setheMyOnboardingRequestZone(selectedVal));
    }
    if (selectedVal == null) {
      setData({
        ...datas,
        zone: "",
      });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setheMyOnboardingRequestZone({ value: "", label: "ALL" }));
    }
  };

  const handleSelectChange = (selectedVal) => {
    setdtPageindex(1);
    dispatch(setTheMyonboardingRequestBranchList({ value: "", label: "ALL" }));

    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      setData({
        ...datas,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
      dispatch(setheMyOnboardingRequestState(selectedVal));
      dispatch(setheMyOnboardingRequesteRegion({ value: "", label: "ALL" }));
      dispatch(setheMyOnboardingRequestZone({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setheMyOnboardingRequestState({ value: "", label: "ALL" }));
      dispatch(setheMyOnboardingRequesteRegion({ value: "", label: "ALL" }));
      dispatch(setheMyOnboardingRequestZone({ value: "", label: "ALL" }));

      setData({
        ...datas,
        state: "",
        zone: "",
        region: "",
      });
    }
  };
  useDebouncedEffect(
    () => {
      if (setSearchDebounance) {
        setSearched({
          ...SearchedVal,
          stateSearch: SearchDebounance.stateSearch,
          regionSearch: SearchDebounance.regionSearch,
          zoneSearch: SearchDebounance.zoneSearch,
        });
        setSearch(SearchDebounance.Clientsearch);
      }
    },
    500,
    [SearchDebounance],
  );

  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      stateSearch: Val,
    });
  };

  ///---Region-----------------
  const handleInputRegion = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      regionSearch: Val,
    });
  };
  ///----Zone---Name
  const handleInputZone = (Val) => {
    setSearchDebounance({
      ...SearchDebounance,
      zoneSearch: Val,
    });
  };
  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];
  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + "...";
  };
  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
  };

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
    }
  };
  const columns = useMemo(
    () =>
      [
        {
          Header: "Tnx Id",
          accessor: "",
          Cell: (row) => {
            if (
              row.row.original != undefined &&
              row.row.original != null &&
              row.row.original.user_id.id != undefined &&
              row.row.original.user_id.id != null
            ) {
              const userId = row.row.original.user_id.id;
              const lastFourDigits = userId.slice(-6);
              return <p className="PTAGs">{lastFourDigits}</p>;
            }
          },
        },
        {
          Header: "Emp Code",
          accessor: "",
          Cell: (row) => {
            return (
              <>
                <div className="UserName" style={{ cursor: "pointer" }}>
                  <div className="">
                    {row.row.original.user_id != undefined &&
                    row.row.original.user_id != null &&
                    row.row.original.user_id != "" &&
                    row.row.original.user_id.user_uid != undefined &&
                    row.row.original.user_id.user_uid != null &&
                    row.row.original.user_id.user_uid != "" ? (
                      <span>{row.row.original.user_id.user_uid}</span>
                    ) : (
                      <>--</>
                    )}
                  </div>
                </div>
              </>
            );
          },
        },
        {
          Header: "Employee Name",
          accessor: "",
          Cell: (row) => {
            return (
              <>
                <div className="UserName" style={{ cursor: "pointer" }}>
                  <div className="">
                    {row.row.original.user_id != undefined &&
                    row.row.original.user_id != null &&
                    row.row.original.user_id != "" &&
                    row.row.original.user_id.first_name != undefined &&
                    row.row.original.user_id.first_name != null &&
                    row.row.original.user_id.first_name != "" ? (
                      <span>
                        {capitalizeFirstLetter(
                          row.row.original.user_id.first_name,
                        )}
                      </span>
                    ) : (
                      <>--</>
                    )}
                  </div>
                </div>
              </>
            );
          },
        },
        {
          Header: "Designation",
          accessor: "",
          Cell: (row) => {
            const [showTooltip, setShowTooltip] = useState(false);

            return (
              <>
                <span>
                  {row.row.original.user_id.user_role.role != null &&
                  row.row.original.user_id.user_role.role != undefined &&
                  row.row.original.user_id.user_role.role != "" ? (
                    <div
                      className="UserName"
                      onMouseEnter={() => setShowTooltip(true)}
                      onMouseLeave={() => setShowTooltip(false)}
                      style={{ position: "relative" }}
                    >
                      <>
                        {
                          // row.row.original.role.length > 10 ? (
                          //   truncateText(row.row.original.role, 10)
                          // ) :
                          <>{row.row.original.user_id.user_role.role}</>
                        }
                      </>
                      {showTooltip && (
                        <div className="custom-tooltip">
                          {row.row.original.user_id.user_role.role}
                        </div>
                      )}
                    </div>
                  ) : (
                    <span>{"---"} </span>
                  )}
                </span>
              </>
            );
          },
        },

        {
          Header: "Mobile",
          accessor: "",
          Cell: (row) => {
            return (
              <>
                {row.row.original.user_id != null &&
                row.row.original.user_id.phone_number != null &&
                row.row.original.user_id.phone_number != "" &&
                row.row.original.user_id.phone_number != undefined ? (
                  <>
                    {row.row.original.user_id.phone_number != undefined ? (
                      <div className="UserName">
                        <span className="KYcRoles">
                          {row.row.original.user_id.phone_number}
                        </span>
                      </div>
                    ) : (
                      <div className="UserName">
                        <span className="KYcRoles">---</span>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="UserName">
                    <span className="KYcRoles">{"----"}</span>
                  </div>
                )}
              </>
            );
          },
        },

        {
          Header: "Created date",
          accessor: "",
          Cell: (row) => {
            const dateString = row.row.original.created_at;
            const dateObject = new Date(dateString);
            const hours = dateObject.getHours();
            const minutes = dateObject.getMinutes();
            const seconds = dateObject.getSeconds();
            const amOrPm = hours >= 12 ? "PM" : "AM";
            const twelveHourFormat = hours % 12 || 12;

            const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

            const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

            return (
              <>
                <p className="PTAGs">
                  {`${
                    row.row.original.created_at.slice(0, 10)
                    // +
                    // "  " +
                    // formattedTime
                  }`}
                </p>
              </>
            );
          },
        },

        {
          Header: "Branch",
          accessor: "",
          Cell: (row) => {
            const [showTooltip, setShowTooltip] = useState(false);

            return (
              <>
                {row.row.original.client_id != null &&
                row.row.original.client_id != undefined &&
                row.row.original.client_id.client_name != "" &&
                row.row.original.client_id.client_name != undefined ? (
                  <div
                    className="UserName"
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                    style={{ position: "relative" }} // Relative positioning for tooltip placement
                  >
                    <span>
                      {row.row.original.client_id.client_name.length > 12 ? (
                        <>
                          {row.row.original.client_id.client_name.slice(0, 12)}
                          ...
                        </>
                      ) : (
                        <>{row.row.original.client_id.client_name}</>
                      )}
                    </span>

                    {/* Custom tooltip */}
                    {showTooltip && (
                      <div className="custom-tooltip">
                        {row.row.original.client_id.client_name}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="UserName">
                    <span>---</span>
                  </div>
                )}
              </>
            );
          },
        },

        // {
        //   Header: "Zone",
        //   accessor: "",
        //   Cell: (row) => {
        //     return (
        //       <>
        //         {row.row.original.user_id != null &&
        //         row.row.original.user_id.zone_id != null &&
        //         row.row.original.user_id.zone_id != undefined ? (
        //           <>
        //             {row.row.original.user_id.zone_id != undefined && row.row.original.user_id.zone_id.length >  0 ? (
        //               <div className="UserName">
        //                 <span className="PTAGs">
        //                   {/* {row.row.original.user_id.zone_id.zone_name} */}

        //                   {row.row.original.user_id.zone_id.map((item) => {
        //                     return (
        //                       <>
        //                         {item.zone_name.length > 10 ? (
        //                           <p
        //                           data-tooltip-id="list-ToolTips"
        //                           data-tooltip-content={item.zone_name}
        //                             className="PTAGs"
        //                           >
        //                             {item.zone_name.slice(0, 8)}...
        //                           </p>
        //                         ) : (
        //                           <p
        //                           data-tooltip-id="list-ToolTips"
        //                           data-tooltip-content={item.zone_name}
        //                           >
        //                             {item.zone_name}
        //                           </p>
        //                         )}
        //                       </>
        //                     );
        //                   })}
        //                 </span>
        //               </div>
        //             ) : (
        //               <div className="UserName PTAGs">
        //                 <span>---</span>
        //               </div>
        //             )}
        //           </>
        //         ) : (
        //           <div className="UserName PTAGs">
        //             <span>{"----"}</span>
        //           </div>
        //         )}
        //       </>
        //     );
        //   },
        // },

        {
          Header: "Decline Reason",
          accessor: "",
          Cell: (row) => {
            const [showTooltip, setShowTooltip] = useState(false);

            return (
              <>
                {row.row.original.is_decline != null &&
                row.row.original.is_decline != undefined &&
                row.row.original.is_decline ? (
                  <div
                    className="UserName"
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                  >
                    <span>
                      {row.row.original.reason_for_decline.length > 12 ? (
                        <span style={{ color: "red" }}>
                          {row.row.original.reason_for_decline.slice(0, 12)}
                          ...
                        </span>
                      ) : (
                        <span style={{ color: "red" }}>
                          {row.row.original.reason_for_decline}
                        </span>
                      )}

                      {showTooltip && (
                        <div
                          className="custom-tooltip"
                          style={{ textWrap: "wrap", width: "365px" }}
                        >
                          {row.row?.original?.reason_for_decline}
                        </div>
                      )}
                    </span>
                  </div>
                ) : (
                  <div className="UserName">
                    <span style={{ color: "red" }}>---</span>
                  </div>
                )}
              </>
            );
          },
        },
        {
          Header: "Status",
          accessor: "",
          Cell: (row) => {
            const {
              is_basic_info,
              is_address_details,
              is_job_description,
              is_id_verification,
              is_bank_details,
              is_previous_employee,
              is_declaration_form,
              is_esi_form,
              create_employee,
              is_education_details,
            } = row.row.original;

            // Statuses based on the conditions
            const statuses = {
              "Basic Information": is_basic_info,
              "Address Details": is_address_details,
              "Job Information": is_job_description,
              // "ID": is_id_verification,
              "Education Details": is_education_details,
              "Bank Details": is_bank_details,
              "Previous Employment Details": is_previous_employee,
              "Declaration Form": is_declaration_form,
              "ESI Form": is_esi_form,
            };

            // Get statuses with true values
            const trueStatuses = Object.keys(statuses).filter(
              (key) => !statuses[key],
            );
            const trueStatuses1 = Object.keys(statuses).filter(
              (key) => statuses[key],
            );

            // Check if all statuses are true
            const allTrue =
              Object.keys(statuses).length === trueStatuses1.length;
            console.log(allTrue && create_employee, "create_employee");

            if (allTrue && create_employee) {
              return (
                <div>
                  <>
                    {/* //----For Payroll Pending */}
                    {!row.row.original.payroll_approved &&
                    row.row.original.is_pending &&
                    row.row.original.create_employee ? (
                      <>
                        <span style={{ color: "red" }}>
                          {" "}
                          Awaiting for payroll
                        </span>
                      </>
                    ) : null}

                    {/* -----RM---pending */}
                    {(row.row.original.payroll_approved &&
                      !row.row.original.is_pending &&
                      !row.row.original.is_decline &&
                      row.row.original.job_description == null) ||
                    (row.row.original.job_description == undefined &&
                      row.row.original.create_employee) ? (
                      <>
                        <span style={{ color: "red" }}>
                          Awaiting for RM approval
                        </span>
                      </>
                    ) : null}

                    {
                      // !row.row.original.is_pending &&
                      // !row.row.original.is_decline &&
                      // row.row.original.job_description != undefined &&
                      // row.row.original.job_description.letter_id != undefined &&
                      // row.row.original.job_description.letter_id.media_url
                      row.row.original.is_pending == false ? (
                        <>
                          <span style={{ color: "green" }}>Kyc Completed</span>
                        </>
                      ) : (
                        <span>
                          {/* {"---"} */}

                          {/* row.row.original.payroll_approved &&
                  !row.row.original.is_pending &&
                  !row.row.original.is_decline ? (
                  <>
                    {/* -------RM---Approve--------------- */}

                          {/* <span style={{ color: "red" }}>RM Approved</span>
                  </>
                ) : null} */}
                        </span>
                      )
                    }

                    {/* -------Payroll---Approve--------------- */}

                    {row.row.original.payroll_approved &&
                    row.row.original.is_pending ? (
                      <>
                        <span style={{ color: "red" }}>
                          Awaiting for RM approval
                        </span>
                      </>
                    ) : null}

                    {!row.row.original.create_employee ? (
                      <>
                        <span style={{ color: "red" }}>Kyc Pending</span>
                      </>
                    ) : null}
                  </>
                </div>
              );
            } else if (allTrue && !create_employee) {
              return (
                <div>
                  <span style={{ color: "red" }}>Kyc Pending</span>
                </div>
              );
            }

            // Get false statuses
            const falseStatuses = Object.keys(statuses).filter(
              (key) => !statuses[key],
            );

            // Check if only one status is false
            const showFalseStatus =
              falseStatuses.length === 1 ? falseStatuses[0] : "";

            // Combine true statuses and the specific false status
            const finalStatuses = [...trueStatuses];
            if (showFalseStatus) {
              finalStatuses.push(showFalseStatus);
            }

            // Remove duplicates
            const uniqueStatuses = [...new Set(finalStatuses)];

            // Limit the number of statuses to 2
            const limitedStatuses = uniqueStatuses.slice(0, 2);

            // Combine statuses into a single string with `-` separator
            const statusText = limitedStatuses.join(" , ");

            return (
              <div>
                <span style={{ color: "red" }}>{statusText}</span>
              </div>
            );
          },
        },
      ].filter(Boolean),
    [],
  );

  const count = (Counts, values, sel, SelectedValues) => {
    console.log(Counts, values, sel, SelectedValues, "qwpiesjklx");
    dispatch(
      setthemyonboardingListedDatas({
        value: SelectedValues.value,
        label: SelectedValues.label,
      }),
    );
    if (SelectedValues.value == "1") {
      SetSelectval({
        ///Completed
        ...selectVal,
        is_pending: "",
        is_decline: "",
        approved: "",
      });
    } else if (SelectedValues.value == "2") {
      SetSelectval({
        ...selectVal,
        is_pending: true,
        is_decline: false,
        approved: "",
      });
    } else if (SelectedValues.value == "3") {
      SetSelectval({
        ...selectVal,
        is_decline: true,
        is_pending: "",
        approved: "",
      });
    } else if (SelectedValues.value == "4") {
      SetSelectval({
        ...selectVal,
        is_decline: "",
        is_pending: "",
        approved: true,
      });
    }
  };

  const ClearState = (counts) => {
    dispatch(setthemyonboardingListedDatas({ value: "1", label: "All" }));
    SetSelectval({
      ...selectVal,
      is_pending: "",
      is_decline: "",
      approved: "",
    });
  };
  const ViewFunctions = (id) => {
    console.log(id, "asxbkbaxkljabk");
    dispatch(setTheApproveRequeststate(5));
    dispatch(SetEmployeeProfileDetailsID(id.user_id.id));
    dispatch(SetISPendingDetails(id.is_pending));
    dispatch(SETBASICFORMcreatedetails(id.id)); ///-----dispatch  a time_line_id-----
    dispatch(SetStatusBTN(false));
    dispatch(setTheUser_ID(id.user_id.id));

    dispatch(SettheBracnhId(id.client_id.id)); //---branchhh
    dispatch(
      settheJobinfoBranchEmployeeProfile({
        value: id.client_id.id,
        label: id.client_id.client_name,
      }),
    );
    dispatch(setTheemployeeRoleId(id.user_id.user_role.id)); //----role
    dispatch(
      setTheRoleObjects({
        value: id.user_id.user_role.id,
        label: id.user_id.user_role.role,
      }),
    );

    dispatch(
      settheJobinfoBranchEmployeeProfile({
        value: id.client_id.id,
        label: id.client_id.client_name,
      }),
    );
    dispatch(
      setTheBranchoptionsFieldAgent({
        value: id.client_id.id,
        label: id.client_id.client_name,
      }),
    ); ////client and role objects

    dispatch(setTheAllFormPdf(id.create_employee));
    dispatch(setEditableActions(2));
    dispatch(
      setTheRoleObjects({
        value: id.user_id.user_role.id,
        label: id.user_id.user_role.role,
      }),
    );
    // dispatch(SettheBracnhId(id.user_id.user_role.id));
    ///---site----
    dispatch(
      setTheZoneObjectinEmployeeList({
        value: id.user_id.zone_id[0].id,
        label: id.user_id.zone_id[0].zone_name,
      }),
    );

    if (id.basic_info != null) {
      dispatch(SetBasiformsID(id.basic_info));
    }

    if (id.basic_info == null) {
      dispatch(SetBasiformsID(""));
    }

    if (id.address_details != null) {
      dispatch(SetAddressId(id.address_details));
    }

    if (id.address_details == null) {
      dispatch(SetAddressId(""));
    }

    if (id.job_description != null && id.job_description.id != null) {
      dispatch(SetJobOfferID(id.job_description.id));
    }

    if (id.job_description == null && id.job_description == undefined) {
      dispatch(SetJobOfferID(""));
    }

    if (id.id_verification != null && id.id_verification != "") {
      dispatch(SetIdVeriications(id.id_verification));
    }

    if (id.id_verification == null) {
      dispatch(SetIdVeriications(""));
    }

    if (id.bank_details != null && id.bank_details != "") {
      dispatch(setBankDetailsId(id.bank_details));
    }

    if (id.bank_details == null) {
      dispatch(setBankDetailsId(""));
    }

    if (id.education_details != null && id.education_details != "") {
      dispatch(SetEducationDetails(id.education_details));
    }

    if (id.education_details == null) {
      dispatch(SetEducationDetails(""));
    }

    if (id.employee_previous != null && id.employee_previous != "") {
      dispatch(SetPreviousEmployeeID(id.employee_previous));
    }

    if (id.employee_previous == null) {
      dispatch(SetPreviousEmployeeID(""));
    }

    if (id.family_details != null && id.family_details != "") {
      dispatch(setfamliydetailsid(id.family_details));
    }

    if (id.family_details == null) {
      dispatch(setfamliydetailsid(""));
    }

    if (id.esi_form != null && id.esi_form != "") {
      dispatch(SetEsiFormIdActions(id.esi_form));
    }

    if (id.esi_form == null) {
      dispatch(SetEsiFormIdActions(""));
    }

    if (id.declaration_form != null && id.declaration_form != "") {
      dispatch(SetDeclarationId(id.declaration_form));
    }

    if (id.declaration_form == null) {
      dispatch(SetDeclarationId(""));
    }

    navigate("/employeeprofile");
    // window.location.href = "/employeeprofile";
  };

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3 class="user-name mb-0">Employee List </h3>
            <br />
          </div>
        </div>
        <div
          className="row Filters "
          style={{
            marginRight: "0px",
            marginLeft: "0px",
            padding: "0px 30px",
            zIndex: "89",
          }}
        >
          <div
            className="col-sm-2"
            style={{ marginTop: "-19px", zIndfex: "99" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect({ value: "", label: "ALL" });
                console.log(e, "jjk9090");
              }}
              value={multiselect}
              labelledBy="Select"
              // placeholder={"Search"}
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px", zIndex: 3 }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
              // placeholder={
              //   datas.state == ""
              //     ? "without selected state you can't select Region"
              //     : "search"
              // }
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Zone
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              value={multiselect3}
              options={nameList5}
              isClearable={true}
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>

          <div
            className="col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Client
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // onSelect={(e) => {
              //   dispatch(SetTheDashboardClientList(e));
              // }}
              onChange={(e) => {
                setdtPageindex(1);
                if (dtpageindex == 1) {
                  HandleClientBranches(e);
                }
              }}
              options={nameList4}
              labelledBy="Select"
              onInputChange={HandleInputBranch}
              isClearable={true}
              value={
                state.StateManagementOverallCall.Myonboarding_RequestBranchList
              }
            />
          </div>
          {/* 
          <div className="col-sm-2 SelectedDate" style={{ marginTop: "-21px" }}>
            <label
              for="validationCustom01 "
              class="form-label"
              style={{ fontSize: "19px", width: "100%" }}
            >
              Select Date
              <span style={{ color: "red" }}>*</span>
            </label>

            <div className="datepicker_dash">
              <DateRangePicker
                defaultValue={
                  state.StateManagementOverallCall.Myonboarding_Range1 != ""
                    ? [
                        new Date(
                          state.StateManagementOverallCall.Myonboarding_Range1
                        ),
                        new Date(
                          state.StateManagementOverallCall.Myonboarding_Range2
                        ),
                      ]
                    : []
                }
                components={{
                  // Hide the clear button
                  ClearButton: () => null,
                }}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // style={{ width: 270, padding: 10 }}
                // onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  if (e != null) {
                    setrange([]);
                    e.forEach((newValue) => {
                      var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                      var localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      // "validtill",
                      handlechangedate(localISOTime);
                    });
                  }
                }}
              />
            </div>
          </div> */}
        </div>

        <div style={{ padding: " 30px 40px", marginTop: "-13px" }}>
          <ReactTable
            data={state.myonboardingDatas.myonboardingDatas}
            columns={columns}
            currentPage={1}
            totalItems={state.myonboardingDatas.Total_Count}
            pagesize={pagesize}
            dtpagesize={20}
            pageindex={pageindex}
            datacount={state.myonboardingDatas.Total_Count}
            onChange={tochange}
            ViewParts={(e) => {
              let value = {
                organization: {
                  id: e.client_id.organization_id,
                },
              };

              dispatch(setSelectedOnboardClient(value));
              ViewFunctions(e);
            }}
            dtpageindex={dtpageindex}
            Filter={true}
            MakeCreate={true}
            // NoFilter ={true}

            values={state.NeededdatasListed.MyonboardingList}
            options={options}
            count={count}
            ClearState={ClearState}
            ApproveRequestFilter={true}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            searchVal={
              TablePositionPersist?.MyonboardingTempPage?.search == "" ||
              TablePositionPersist?.MyonboardingTempPage?.search == undefined
                ? ""
                : TablePositionPersist.MyonboardingTempPage.search
            }
            search_key={true}
          />
        </div>
      </div>
    </>
  );
};

export default MyonboardingTab;
